import { connect } from 'react-redux';
import { actions } from '../../../redux/modules/purchaseOrder';

import OrdersAdm from './OrdersAdm';
import {resetStore} from "../../../redux/modules/login";

const ms2p = (state) => {
    return {
        ...state.purchase_order,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(OrdersAdm);
